var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteCalendarItemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.28564,
    cy: 6.99951,
    r: 7,
    fill: "#808297"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05661 7.00026L10.6738 4.38294C10.7458 4.31089 10.7855 4.21477 10.7856 4.11228C10.7856 4.00972 10.7459 3.91349 10.6738 3.84155L10.4445 3.61226C10.3724 3.54004 10.2762 3.50049 10.1736 3.50049C10.0712 3.50049 9.97507 3.54004 9.90296 3.61226L7.28576 6.22941L4.66844 3.61226C4.59645 3.54004 4.50027 3.50049 4.39772 3.50049C4.29528 3.50049 4.1991 3.54004 4.12711 3.61226L3.89764 3.84155C3.74831 3.99089 3.74831 4.23378 3.89764 4.38294L6.5149 7.00026L3.89764 9.61746C3.8256 9.68963 3.78593 9.78575 3.78593 9.88824C3.78593 9.99074 3.8256 10.0869 3.89764 10.159L4.12705 10.3883C4.19904 10.4604 4.29528 10.5 4.39766 10.5C4.50021 10.5 4.59639 10.4604 4.66838 10.3883L7.2857 7.77106L9.9029 10.3883C9.97501 10.4604 10.0711 10.5 10.1736 10.5H10.1737C10.2762 10.5 10.3723 10.4604 10.4444 10.3883L10.6738 10.159C10.7458 10.0869 10.7855 9.99074 10.7855 9.88824C10.7855 9.78575 10.7458 9.68963 10.6738 9.61752L8.05661 7.00026Z",
    fill: "#F2F3F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.78564,
    y: 3.49951,
    width: 7,
    height: 7,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCalendarItemIcon);
export default __webpack_public_path__ + "static/media/DeleteCalendarItemIcon.73095cb37582a79c90eff229b89ac042.svg";
export { ForwardRef as ReactComponent };